module.exports = __webpack_public_path__ + "static/media/hust.39f6a0c9.svg";